/* Measure visible navigation so the opening section shares one screen with it. */
(() => {
  const root = document.documentElement;
  let observer;
  function measure() {
    const password = document.body.classList.contains('password');
    const nav = document.querySelector(password ? '.password-header' : '.section-header');
    const announcements = [...document.querySelectorAll('.announcement-bar-section')];
    const navHeight = nav ? nav.getBoundingClientRect().height : 0;
    const announcementHeight = announcements.reduce((total, el) => total + el.getBoundingClientRect().height, 0);
    root.style.setProperty('--bv-nav-height', `${navHeight}px`);
    root.style.setProperty('--bv-announcement-height', `${announcementHeight}px`);
    root.style.setProperty('--bv-header-space', `${navHeight + announcementHeight}px`);
  }
  function init() {
    observer?.disconnect();
    observer = new ResizeObserver(measure);
    document.querySelectorAll('.password-header,.section-header,.announcement-bar-section').forEach(el => observer.observe(el));
    measure();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('resize', measure, { passive: true });
  document.addEventListener('shopify:section:load', init);
})();
